document.addEventListener('DOMContentLoaded', function () {
  try {
    // ---------- helpers ----------
    const parseMoney = (t) =>
      t ? Number(String(t).replace(/[^0-9.,]/g, '').replace(/,/g, '')) || 0 : 0;

    const CURRENCY =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';

    const fmt = (n) =>
      new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }).format(n);

    // ---------- scope / elements ----------
    let outEl = document.getElementById('qb-inline-price');
    const scope = (outEl && outEl.closest('.product__info-container')) || document;

    const qtyRow =
      scope.querySelector('.price-per-item__container') ||
      scope.querySelector('.product-form__quantity') ||
      scope.querySelector('[id^="Quantity-Form-"]');

    if (!outEl) { outEl = document.createElement('div'); outEl.id = 'qb-inline-price'; }
    if (qtyRow && !qtyRow.contains(outEl)) qtyRow.appendChild(outEl);
    outEl.classList.add('qb-inline-price');

    const qtyInput =
      scope.querySelector('input[name="quantity"]') ||
      scope.querySelector('[id^="Quantity-"]');

    const priceEl =
      scope.querySelector('.price-item--sale') ||
      scope.querySelector('.price-item--regular') ||
      scope.querySelector('.price-item');

    if (!qtyInput || !priceEl || !qtyRow) return;

    const priceBlock =
      scope.querySelector('[id^="price-"]') ||
      priceEl.closest('.price') ||
      priceEl.parentElement;

    // ---------- CSS ----------
    (function injectCss() {
      if (document.getElementById('qb-inline-style')) return;
      const css = `
        .product__info-container .price-per-item__container{display:flex;align-items:center;gap:14px;flex-wrap:wrap}
        .product__info-container .price-per-item__container .qb-inline-price{margin-left:auto;text-align:right;display:flex;flex-direction:column}
        .qb-inline-price .qb-total{font-weight:700;font-size:clamp(18px,2.2vw,22px);line-height:1.15}
        .qb-inline-price .qb-meta{font-size:13px;line-height:1.2;opacity:.85}
        .qb-inline-price .qb-meta s{opacity:.7;margin-right:6px;text-decoration-thickness:2px}
        .qb-append-range{ margin-left:.35em; opacity:.9 }
        @media (max-width:749px){
          .product__info-container .price-per-item__container{gap:10px}
          .product__info-container .price-per-item__container .qb-inline-price{margin-left:0;text-align:left}
        }
      `;
      const style = document.createElement('style');
      style.id = 'qb-inline-style';
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);
    })();

    // ---------- tier parsing ----------
    function findTable() {
      return (
        scope.querySelector('.shopacado-discount-table') ||
        scope.querySelector('.scd-quantity-breaks') ||
        scope.querySelector('.qikify-volume-discount') ||
        scope.querySelector('.qikify_discount_table') ||
        scope.querySelector('[class*="quantity"][class*="break"]') ||
        scope.querySelector('[class*="discount"][class*="table"]') ||
        scope.querySelector('volume-pricing') ||
        null
      );
    }

    function parseTiers() {
      const base = parseMoney(priceEl.textContent);
      const table = findTable();
      const tiers = [];

      if (table) {
        const rows = Array.from(table.querySelectorAll('li, tr, .row, [data-tier]'));
        rows.forEach((row) => {
          const raw = row.textContent || '';
          const text = raw.replace(/\s+/g, ' ').trim();
          const lower = text.toLowerCase();

          const mQty = text.match(/(\d+)\s*\+/);
          if (!mQty) return;
          const min = parseInt(mQty[1], 10);

          let unit = null;

          if (lower.includes('off')) {
            const mPct = lower.match(/(\d{1,3})\s*%\s*off/);
            if (mPct) {
              unit = +(parseMoney(priceEl.textContent) * (1 - parseInt(mPct[1], 10) / 100)).toFixed(2);
            } else {
              const mOff = raw.match(/([£$€]\s*\d+(?:[.,]\d{2})?)/);
              if (mOff) {
                const off = parseMoney(mOff[1]);
                unit = Math.max(0, +(parseMoney(priceEl.textContent) - off).toFixed(2));
              }
            }
          }

          if (unit === null) {
            const mEach = raw.match(/([£$€]\s*\d+(?:[.,]\d{2})?).{0,20}\b(each|ea)\b/i);
            if (mEach) unit = parseMoney(mEach[1]);
          }

          if (unit === null && !lower.includes('off')) {
            const monies = raw.match(/([£$€]\s*\d+(?:[.,]\d{2})?)/g);
            if (monies && monies.length === 1) unit = parseMoney(monies[0]);
          }

          if (unit === null && lower.includes('0.00 off')) unit = parseMoney(priceEl.textContent);

          if (min && unit && unit > 0) tiers.push({ min, price: unit });
        });
      }

      if (!tiers.length) tiers.push({ min: 1, price: parseMoney(priceEl.textContent) });
      tiers.sort((a, b) => a.min - b.min);
      return tiers;
    }

    function tierForQty(q, tiers) {
      let chosen = tiers[0];
      for (const t of tiers) if (q >= t.min) chosen = t;
      return chosen;
    }

    let tiers = parseTiers();

    // ---------- inline total next to qty ----------
    function renderInline() {
      const q = Math.max(1, parseInt(qtyInput.value || '1', 10));
      const base = parseMoney(priceEl.textContent);
      const t = tierForQty(q, tiers);
      const per = t.price;
      const subtotal = per * q;
      const full = base * q;
      const saving = full - subtotal;
      const discounted = saving > 0.005;

      const meta = discounted ? `<s>${fmt(full)}</s> · ${fmt(per)} each` : `${fmt(per)} each`;

      outEl.innerHTML =
        `<div class="qb-total">Total ${fmt(subtotal)}</div>` +
        `<div class="qb-meta">${meta}</div>`;
    }

    // ---------- append "to £FULL" to existing "From £…" ----------
    function findFromEl() {
      if (!priceBlock) return null;
      let el =
        priceBlock.querySelector('.lowest-price, .qvds-lowest-price, .shopacado-lowest, .scd-lowest, .qikify-lowest') ||
        null;

      if (el) return el;

      const candidates = Array.from(priceBlock.querySelectorAll('*:not(script):not(style)'));
      for (const node of candidates) {
        const txt = (node.textContent || '').trim().toLowerCase();
        if ((/^from\b/.test(txt) || txt.includes('as low as')) && /£|\$|€/.test(txt)) return node;
      }
      return null;
    }

    function renderFromAppend() {
      const base = parseMoney(priceEl.textContent);
      if (!priceBlock) return;
      const fromEl = findFromEl();
      if (!fromEl) return;

      const min = Math.min.apply(null, (tiers && tiers.length ? tiers : [{ price: base }]).map(t => t.price));
      const hasDiscount = min < base - 0.005;

      // existing span (if any)
      let span = fromEl.querySelector('.qb-append-range');

      if (hasDiscount) {
        const desired = ` to ${fmt(base)}`;
        if (!span) {
          span = document.createElement('span');
          span.className = 'qb-append-range';
          span.textContent = desired;
          fromEl.appendChild(span); // one append -> one mutation
        } else if (span.textContent !== desired) {
          span.textContent = desired; // update only if changed
        }
        // never hide the "From" itself
      } else if (span) {
        span.remove(); // remove our own span when no discount
      }
    }

    function renderAll() {
      renderInline();
      renderFromAppend();
    }

    // qty changes
    qtyInput.addEventListener('input', renderInline);
    qtyInput.addEventListener('change', renderInline);
    const qWrap = qtyInput.closest('quantity-input') || qtyInput.parentElement;
    if (qWrap) qWrap.addEventListener('click', (e) => {
      if (e.target.closest('.quantity__button')) setTimeout(renderInline, 0);
    });

    // table / price changes => re-parse + render
    const table = findTable();
    if (table) new MutationObserver(() => { tiers = parseTiers(); renderAll(); })
      .observe(table, { childList: true, subtree: true });

    new MutationObserver(() => { tiers = parseTiers(); renderAll(); })
      .observe(priceEl, { childList: true, subtree: true });

    // watch price block WITHOUT characterData to avoid loops when we adjust our span
    if (priceBlock) new MutationObserver(() => { renderFromAppend(); })
      .observe(priceBlock, { childList: true, subtree: true });

    // debug helper
    window.__qbDebug = () => ({ base: parseMoney(priceEl.textContent), tiers });

    renderAll();
  } catch (e) {
    console.warn('qb-live-price.js error:', e);
  }
});
